import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../DataTable";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

function ReporteOperativo() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;
  // const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  // const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  // const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  // const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  // const URL_TELAS = process.env.REACT_APP_URL_TELAS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");
  
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  // const [proveedores, setProveedores] = useState([]);
  // const [selectedProveedor, setSelectedProveedor] = useState("");
  // const [selectedProveedorCompras, setSelectedProveedorCompras] = useState("");

  // const [clientes, setClientes] = useState([]);
  // const [selectedCliente, setSelectedCliente] = useState("");

  // const [colores, setColores] = useState([]);
  // const [selectedColor, setSelectedColor] = useState("");
  // const [selectedColorCompras, setSelectedColorCompras] = useState("");
  // const [telas, setTelas] = useState([]);
  // const [selectedTela, setSelectedTela] = useState("");
  // const [selectedTelaCompras, setSelectedTelaCompras] = useState("");

  const [reporteOperativoVentas, setReporteOperativoVentas] = useState([]);
  const [reporteOperativoGastos, setReporteOperativoGastos] = useState([]);
  const [reporteOperativoCompras, setReporteOperativoCompras] = useState([]);
  const [reporteOperativoNotasCxP, setReporteOperativoNotasCxP] = useState([]);

  useMemo(() => {
    axios
      .get(`${URL_DASHBOARDS}ReporteOperativo/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allReporteOperativoVentas = response.data.dataVentas;
        setReporteOperativoVentas(allReporteOperativoVentas);

        let allReporteOperativoGastos = response.data.dataGastos;
        setReporteOperativoGastos(allReporteOperativoGastos);

        let allReporteOperativoCompras = response.data.dataCompras;
        setReporteOperativoCompras(allReporteOperativoCompras);

        let allReporteOperativoNotasCxP = response.data.dataNotasCxP;
        setReporteOperativoNotasCxP(allReporteOperativoNotasCxP);
      })
      .catch((err) => {
        console.log(err);
      });

      //  axios
      //       .get(URL_PROVEEDORES, {
      //         headers: {
      //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //         },
      //       })
      //       .then((response) => {
      //         let allProveedores = response.data;
      //         setProveedores(allProveedores);
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //       });

      //       axios
      //       .get(URL_CLIENTES, {
      //         headers: {
      //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //         },
      //       })
      //       .then((response) => {
      //         let allClientes = response.data;
      //         setClientes(allClientes);
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //       });
      //       axios
      //       .get(URL_COLORES, {
      //         headers: {
      //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //         },
      //       })
      //       .then((response) => {
      //         let allColores = response.data;
      //         setColores(allColores);
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //       });
      //       axios
      //       .get(URL_TELAS, {
      //         headers: {
      //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      //         },
      //       })
      //       .then((response) => {
      //         let allTelas = response.data;
      //         setTelas(allTelas);
      //       })
      //       .catch((err) => {
      //         console.log(err);
      //       });
  }, [selectedFechaInicio, selectedFechaFin]);

  function excel() {
    const dataExcelVentas = reporteOperativoVentas.map((a) => {
      // if (
      //   (selectedCliente == 0 || selectedCliente == a.idCliente) &&
      //   (selectedColor == 0 || selectedColor == a.idColor) &&
      //   (selectedTela == 0 || selectedTela == a.idTela)
      // ) {
      return {
        Numero: a.numero,
        Fecha: a.fecha,
        Cliente: a.cliente,
        PedidoCliente: a.pedidoCliente,
        Subtotal: a.subtotal,
        IVA: a.iva,
        Total: a.total,
      }
    // }
    });
    const dataExportExcelVentas = Object.values(dataExcelVentas);
    const dataExcelVentasLimpia = dataExportExcelVentas.filter(function (el) {
      return el != null;
    });

    const dataExcelCompras = reporteOperativoCompras.map((a) => {
      // if (
      //   (selectedProveedorCompras == 0 || selectedProveedorCompras == a.idProveedor) &&
      //   (selectedColorCompras == 0 || selectedColorCompras == a.idColor) &&
      //   (selectedTelaCompras == 0 || selectedTelaCompras == a.idTela)
      // ) {
      return {
        Numero: a.numero,
        Fecha: a.fecha,
        FacturaProveedor: a.factura_proveedor,
        Proveedor: a.proveedores,
        Subtotal: a.subtotal,
        IVA: a.iva,
        Total: a.total,
      }
    // }
    });
    const dataExportExcelCompras = Object.values(dataExcelCompras);
    const dataExcelComprasLimpia = dataExportExcelCompras.filter(function (el) {
      return el != null;
    });

      const dataExcelNotasCxP = reporteOperativoNotasCxP.map((a) => {
      // if (
      //   (selectedProveedorNotasCxP == 0 || selectedProveedorNotasCxP == a.idProveedor) &&
      //   (selectedColorNotasCxP == 0 || selectedColorNotasCxP == a.idColor) &&
      //   (selectedTelaNotasCxP == 0 || selectedTelaNotasCxP == a.idTela)
      // ) {
      return {
        Numero: a.numero,
        Fecha: a.fecha,
        Proveedor: a.proveedores,
        Cliente: a.clientes,
        Subtotal: a.subtotal,
        IVA: a.iva,
        Total: a.total,
      }
    // }
    });
    const dataExportExcelNotasCxP = Object.values(dataExcelNotasCxP);
    const dataExcelNotasCxPLimpia = dataExportExcelNotasCxP.filter(function (el) {
      return el != null;
    });

     const dataExcelGastos = reporteOperativoGastos.map((a) => {
      // if (
      //   (selectedCliente == 0 || selectedCliente == a.idCliente) &&
      //   (selectedColor == 0 || selectedColor == a.idColor) &&
      //   (selectedTela == 0 || selectedTela == a.idTela)
      // ) {
      return {
        Numero: a.numero,
        Fecha: a.fecha,
        Concepto: a.concepto,
        Descripcion: a.descripcion,
        Factura: a.factura,
        Subtotal: a.subtotal,
        IVA: a.iva,
        Total: a.total,
      }
    // }
    });


    
    const dataExportExcelGastos = Object.values(dataExcelGastos);
    const dataExcelGastosLimpia = dataExportExcelGastos.filter(function (el) {
      return el != null;
    });


    var option = {};

    option.fileName = "ReporteOperativo";

    option.datas = [
      {
        sheetData: dataExcelVentasLimpia,
        sheetName: "Ventas",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Cliente",
          "PedidoCliente",
          "Subtotal",
          "IVA",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Cliente",
          "PedidoCliente",
          "Subtotal",
          "IVA",
          "Total",
        ],
      },
       

      {
        sheetData: dataExcelComprasLimpia,
        sheetName: "Compras",
        sheetFilter: [
          "Numero",
          "Fecha",
          "FacturaProveedor",
          "Proveedor",
          "Subtotal",
          "IVA",
          "Total",
        ],
        sheetHeader: [
           "Numero",
          "Fecha",
          "FacturaProveedor",
          "Proveedor",
          "Subtotal",
          "IVA",
          "Total",
        ],
      },

      {
        sheetData: dataExcelNotasCxPLimpia,
        sheetName: "NotasCxP",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Proveedor",
          "Cliente",
          "Subtotal",
          "IVA",
          "Total",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Proveedor",
          "Cliente",
          "Subtotal",
          "IVA",
          "Total",
        ],
      },
      {
        sheetData: dataExcelGastosLimpia,
        sheetName: "Gastos",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Concepto",
          "Descripcion",
          "Factura",
          "Subtotal",
          "IVA",
          "Total",
        ],
        sheetHeader: [
           "Numero",
          "Fecha",
          "Concepto",
          "Descripcion",
          "Factura",
          "Subtotal",
          "IVA",
          "Total",
        ],
      },
    ];

    const resumen = [
  {
    Concepto: "Ventas",
    Monto: totalVentasDinero,
  },
  {
    Concepto: "Compras",
    Monto: totalComprasDinero,
  },
  {
    Concepto: "Notas CxP",
    Monto: totalNotasCxPDinero,
  },
  {
    Concepto: "Gastos",
    Monto: totalGastosDinero,
  },
  {
    Concepto: "Resultado Neto",
    Monto:
      totalVentasDinero -
      totalComprasDinero -
      totalNotasCxPDinero -
      totalGastosDinero,
  },
];

// Agregar como hoja nueva al objeto option.datas
option.datas.push({
  sheetData: resumen,
  sheetName: "Resumen",
  sheetFilter: ["Concepto", "Monto"],
  sheetHeader: ["Concepto", "Monto"],
});


    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  let totalVentasDinero = 0;
  let totalVentasMetros = 0;
  let totalGastosDinero = 0;
  let totalGastosMetros = 0;
  let totalComprasDinero = 0;
  let totalComprasMetros = 0;
  let totalNotasCxPDinero = 0;
  let totalNotasCxPMetros = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_compras ? (
        <div className="card container col-11">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuReportes"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align="center"> Reporte Operativo</h3>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            {/* Ventas */}
            <tbody>
              <tr>
                <th>VENTAS</th>
                
                {/* <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedProveedor}
                    onChange={(e) => {
                      setSelectedProveedor(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {proveedores
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedTela}
                    onChange={(e) => {
                      setSelectedTela(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {telas
                      .sort((a, b) =>
                        a.codigo > b.codigo ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.codigo} {a.nombre}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedColor}
                    onChange={(e) => {
                      setSelectedColor(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {colores
                      .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </th>
                <th></th>
                <th></th>
                <th></th> */}
              </tr>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Cliente</th>
                <th>Pedido Cliente</th>
                <th>Subtotal</th>
                <th>IVA</th>
                <th>Total</th>
              </tr>
              {reporteOperativoVentas.map((a) => {
                //      if ((
                //       selectedCliente == 0 ||
                //       selectedCliente == a.idCliente
                //     ) &&
                // (selectedColor == 0 || selectedColor == a.idColor) &&
                // (selectedTela == 0 || selectedTela == a.idTela) &&
                //     (selectedProveedor == 0 || selectedProveedor == a.idProveedor)){
                // // {commentsData.map((a) => {
                // {
                  // totalVentasMetros = totalVentasMetros + a.cantidad;
                  totalVentasDinero = totalVentasDinero + a.total;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.pedidoCliente}</td>
                       <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subtotal)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.iva)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total)}
                      </td>
                    </tr>
                  );
                // }
              // }
              }
              )}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalVentasDinero)}
                </td>
              </tr>
            </tbody>
            <br />
            <br />


            {/* Compras */}
            <tbody>
              <tr>
                <th>COMPRAS</th>
                {/* <th></th>
                <th>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={selectedProveedorCompras}
                    onChange={(e) => {
                      setSelectedProveedorCompras(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {proveedores
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedTelaCompras}
                    onChange={(e) => {
                      setSelectedTelaCompras(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {telas
                      .sort((a, b) =>
                        a.codigo > b.codigo ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.codigo} {a.nombre}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedColorCompras}
                    onChange={(e) => {
                      setSelectedColorCompras(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {colores
                      .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </th>
                <th></th>
                <th></th>
                <th></th> */}
              </tr>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Fact Prov</th>
                <th>Proveedor</th>
                <th>Subtotal</th>
                <th>IVA</th>
                <th>Total</th>
              </tr>
              {reporteOperativoCompras.map((a) => {
              //   if ((
              //     selectedProveedorCompras == 0 ||
              //     selectedProveedorCompras == a.idProveedor
              //   )&&
              //   (selectedColorCompras == 0 || selectedColorCompras == a.idColor) &&
              //   (selectedTelaCompras == 0 || selectedTelaCompras == a.idTela)
              // ) {
                  // {commentsData.map((a) => {
                  totalComprasDinero = totalComprasDinero + a.total;
                  // totalComprasMetros = totalComprasMetros + a.cantidad;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.factura_proveedor}</td>
                      <td>{a.proveedores}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subtotal)}
                      </td>
                       <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.iva)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total)}
                      </td>
                    </tr>
                  );
                // }
              })}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalComprasDinero)}
                </td>
              </tr>
            </tbody>
            <br />
            <br />

            {/* NOTAS CXP */}
            <tbody>
              <tr>
                <th>NOTAS CXP</th>
                {/* <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th> */}
              </tr>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Proveedor</th>
                <th>Cliente</th>
                <th>Subtotal</th>
                <th>IVA</th>
                <th>Total</th>
              </tr>
              {reporteOperativoNotasCxP.map((a) => {
                // {commentsData.map((a) => {
                {
                  totalNotasCxPDinero = totalNotasCxPDinero + a.total;
                  // totalNotasCxPMetros = totalNotasCxPMetros + a.cantidad;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.proveedor}</td>
                      <td>{a.cliente}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subtotal)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.iva)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total)}
                      </td>
                    </tr>
                  );
                }
              })}

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalNotasCxPDinero)}
                </td>
              </tr>
            </tbody>
            <br />
            <br />

             {/* Gastos */}
            <tbody>
              <tr>
                <th>GASTOS</th>
                {/* <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedProveedor}
                    onChange={(e) => {
                      setSelectedProveedor(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {proveedores
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedCliente}
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {clientes
                      .sort((a, b) =>
                        a.nombre_comercial > b.nombre_comercial ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedTela}
                    onChange={(e) => {
                      setSelectedTela(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {telas
                      .sort((a, b) =>
                        a.codigo > b.codigo ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.codigo} {a.nombre}</option>;
                      })}
                  </Input>
                </th>
                <th>
                <Input
                    bsSize="sm"
                    type="select"
                    value={selectedColor}
                    onChange={(e) => {
                      setSelectedColor(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona</option>
                    {colores
                      .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </th>
                <th></th>
                <th></th>
                <th></th> */}
              </tr>
              <tr>
                <th>Numero</th>
                <th>Fecha</th>
                <th>Concepto</th>
                <th>Descripcion</th>
                <th>Factura</th>
                <th>Subtotal</th>
                <th>Iva</th>
                <th>Total</th>
              </tr>
              {reporteOperativoGastos.map((a) => {
                //      if ((
                //       selectedCliente == 0 ||
                //       selectedCliente == a.idCliente
                //     ) &&
                // (selectedColor == 0 || selectedColor == a.idColor) &&
                // (selectedTela == 0 || selectedTela == a.idTela) &&
                //     (selectedProveedor == 0 || selectedProveedor == a.idProveedor)){
                // // {commentsData.map((a) => {
                // {
                  // totalGastosMetros = totalGastosMetros + a.cantidad;
                  totalGastosDinero = totalGastosDinero + a.total;
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.concepto}</td>
                      <td>{a.descripcion}</td>
                      <td>{a.factura}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.subtotal)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.iva)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.total)}
                      </td>
                    </tr>
                  );
                // }
              // }
              })
              }

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalGastosDinero)}
                </td>
              </tr>
            </tbody>


            <br />
            <br />

             {/* Gastos */}
            <tbody>
              <tr>
                <th>RESUMEN</th>
             
              </tr>
              <tr>
                <th>Concepto</th>
                <th>Monto</th>
              </tr>
                    <tr>
    <td>Ventas</td>
    <td>
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(totalVentasDinero)}
    </td>
  </tr>
  <tr>
    <td>Compras</td>
    <td>
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(totalComprasDinero)}
    </td>
  </tr>
  <tr>
    <td>Notas CxP</td>
    <td>
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(totalNotasCxPDinero)}
    </td>
  </tr>
  <tr>
    <td>Gastos</td>
    <td>
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(totalGastosDinero)}
    </td>
  </tr>
  <tr>
    <td className="negrita">Resultado Neto</td>
    <td className="negrita">
      {new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(
        totalVentasDinero -
        totalComprasDinero -
        totalNotasCxPDinero -
        totalGastosDinero
      )}
    </td>
  </tr>

            </tbody>
            <br />
            <br />
          </Table>
        </div>
      ) : undefined}
      <br />
    </>
  );
}

export default ReporteOperativo;
